<template>
    <div style='min-height: calc(100vh - 176px);' class="flex flex-wrap mt-4">
        <div class="w-full mb-12 px-4">
            <card-table
                pageTitle="Наука" 
                :pageUrl="pageUrl"
                field_key="title"
                path='/admin/science/'
                :filedWidth="filedWidth"
                dropDownComponentString="SubmitCancel"
            />
        </div>
    </div>
</template>

<script>
import CardTable from "@/components/Cards/CardTableUsers.vue";
import { API_BASE } from '@/const/uri';

export default {
    data() {
        return {
            pageUrl: API_BASE.science.list,
            filedWidth: {},
        }
    },
    components: {
        CardTable,
    },
};
</script>
